<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <my-swiper></my-swiper>
    </div>
  </div>
</template>
<script>
import mySwiper from './my-swiper.vue';
export default {
  components: { mySwiper },
  name: 'DragonBoat',
  data() {
    return {};
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #e5f9ff;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
  }
}
</style>
